import React from "react";
import BeatLoader from "react-spinners/BeatLoader";

// Flat scrolling list in the order the server sorted them (plan §5.2). Services with
// no resource assigned never reach here — the server filters them out, since a
// service nobody performs is not bookable (§0).

type Service = {
  id: string;
  name: string;
  duration: number;
  description?: string;
  price?: number;
};

const formatDuration = (minutes: number): string => {
  if (!minutes || minutes <= 0) {
    return "";
  }
  const hours = Math.floor(minutes / 60);
  const remainder = minutes % 60;
  if (!hours) {
    return `${remainder} min`;
  }
  return remainder ? `${hours} hr ${remainder} min` : `${hours} hr`;
};

const formatPrice = (price?: number): string => (typeof price === "number" ? `$${price.toFixed(2)}` : "");

const SelectServiceStep = ({ services, onSelect, buttonStyle, loading, title = "Select a service" }) => {
  if (loading) {
    return (
      <div className="appointments__loading">
        <BeatLoader margin={2.5} size={15} color={buttonStyle?.backgroundColor} />
      </div>
    );
  }

  if (!services?.length) {
    return (
      <div className="appointments__step">
        <div className="self-reservations__title">{title}</div>
        <div className="appointments__empty">There are no services available to book right now.</div>
      </div>
    );
  }

  return (
    <div className="appointments__step">
      <div className="self-reservations__title">{title}</div>
      <div className="appointments__list">
        {services.map((service: Service) => (
          <button key={service.id} type="button" className="appointments__option" onClick={() => onSelect(service)}>
            <span className="appointments__option-main">
              <span className="appointments__option-name">{service.name}</span>
              {!!service.description && <span className="appointments__option-description">{service.description}</span>}
            </span>
            <span className="appointments__option-meta">
              <span>{formatDuration(service.duration)}</span>
              {!!formatPrice(service.price) && (
                <span className="appointments__option-price">{formatPrice(service.price)}</span>
              )}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SelectServiceStep;
